import { useTranslation } from 'react-i18next';
import { pressList } from '@/mocks/homeData';

export default function PressSection() {
  const { t } = useTranslation();

  return (
    <section id="press" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-10 md:mb-14 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            {t('press.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-700">
            {t('press.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {pressList.map((article) => (
            <a
              key={article.url}
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col justify-between rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
            >
              <div>
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-700 bg-accent-100/80 px-2.5 py-1 rounded-full">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-newspaper-line" />
                    </span>
                    {article.source}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
              </div>
              <div className="mt-5 flex items-center text-xs text-foreground-600 gap-1">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line" />
                </span>
                <span className="whitespace-nowrap">기사 바로가기</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}